import {quesGradeTypes} from '../settingsTypes';

const initialState = {
    allQuestionGrades: [],
    loading: false,
    error: '',
    text: '',
    grade:'',
    totalGradesCount: 0,
    allGrades:[],
    errorgradedelete:false,
    loadinggradedelete:false,
    successgradeupdate: false,
    loadinggradeupdate: false,
    errorgradeupdate:false,
    successgradedelete:false,
    errorgradecreate: '',
    successgradecreate: false,
}

export function gradeReducer(state = initialState, action){
    switch (action.type){
        case quesGradeTypes.CREATE_PAGE_REFRESH:
            return {
                ...state,
                allQuestionGrades: [],
                loading: false,
                error: '',
                text: '',
                grade:'',
                totalGradesCount:0,
                allGrades:[],
                errorgradedelete:false,
                loadinggradedelete:false,
                successgradeupdate: false,
                loadinggradeupdate: false,
                errorgradeupdate:false,
                successgradedelete:false,
                errorgradecreate: '',
                successgradecreate: false,
            }
        //Grade retrieve request sending
        case quesGradeTypes.GET_ALL_QUESTION_GRADES:
            return {
                ...state,
                loading: true,
                text: 'Get all the question grades'
            }
        case quesGradeTypes.GET_ALL_QUESTION_GRADES_REQUEST:
            return {
                ...state,
                loading: true
            }
        case quesGradeTypes.GET_ALL_QUESTION_GRADES_SUCCESS:
            return {
                ...state,
                loading: false,
                allQuestionGrades: action.grades.grades,
                totalGradesCount: action.grades.total_count
            }
        case quesGradeTypes.GET_ALL_QUESTION_GRADES_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        //Grade creation request sending
        case quesGradeTypes.CREATE_GRADE_REQUEST:
            return {
                ...state,
                errorgradecreate: '',
                successgradecreate: false,
                loading: true
            }
        case quesGradeTypes.CREATE_GRADE_SUCCESS:
            var temp = state.allGrades;
            temp.push(action.grades)
            return {
                ...state,
                allGrades: temp,
                grade: action.grades.grade_id,
                successgradecreate: true,
                loading: false
            }
        case quesGradeTypes.CREATE_GRADE_FAILURE:
            return {
                ...state,
                errorgradecreate: action.error,
                loading: false
            }  
        //Grade deletion request sending   
        case quesGradeTypes.DELETE_GRADE_REQUEST:
            return {
            ...state,
            errorgradedelete: '',
            successgradedelete: false,
            loading: true,
            };
        case quesGradeTypes.DELETE_GRADE_SUCCESS:
            return {
            ...state,
            successgradedelete: true,
            loading: false,
            };
        case quesGradeTypes.DELETE_GRADE_FAILURE:
            return {
            ...state,
            errorgradedelete: action.error,
            loading: false,
            };
        //Grade updation request sending
        case quesGradeTypes.UPDATE_GRADE_REQUEST:
            return {
            ...state,
            errorgradeupdate:'',
            successgradeupdate: false,
            loading: true,
            };
        case quesGradeTypes.UPDATE_GRADE_SUCCESS:
            return {
            ...state,
            successgradeupdate: true,
            loading: false,
            };
        case quesGradeTypes.UPDATE_GRADE_FAILURE:
            return {
            ...state,
            errorgradeupdate: action.error,
            loading: false,
            };     
        default:
            return state
    }
}
